/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:15
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2023-01-13 15:19:49
 * @FilePath: \ioc_base\src\modules\historyAlarm\const\HistoryAlarmTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  Dic
} from '$utils'
export const alarmTableOption = function (that) {
  return {
    page: true,
    editBtn: false,
    delBtn: false,
    header: false,
    menuWidth: 80,
    maxHeight: '100%',
    stripe: true,
    menu: false,
    emptyText: that.$t('historyAlarm.label.noData'),
    column: [{
        label: that.$t('historyAlarm.title.alarmTime'),
        prop: 'alarmTime',
        search: true,
        type:'datetimerange'
       
      },
      {
        label: that.$t('historyAlarm.title.alarmLevel'),
        prop: 'alarmLevel',
        width: 140,
        search: true,
        searchSlot:true,
        align: 'center'
      },
      {
        label: that.$t('historyAlarm.title.alarmType'),
        prop: 'alarmTypelabel',
        search: true,
        searchSlot:true
      },
      {
        label: '告警标题',
        prop: 'alarmTitle',
        search: true,

      },
      {
        label: that.$t('historyAlarm.title.alarmArea'),
        prop: 'area',
        //slot: true,
        width: 140,
        align: 'center'
      },
      //所属中队
      // {
      //   label: '所属中队',
      //   prop: 'securityWorkGroupNames',
      //   editDisabled: false,
      //   addDisplay: true,
      //   editDisplay: true,
      //   search: true,
      //   overHidden: true,
      //   span: 5
      // },
      {
        label: "告警来源",
        prop: 'deviceName',
        search: true,
        searchSlot:true
      },
      // {
      //   label: that.$t('historyAlarm.title.alarmLevel'),
      //   prop: 'alarmLevel',
      //   width: 140,
      //   search: false,
      //   searchSlot:false,
      //   align: 'center'
      // },
      //   {
      //     label: '告警ID',
      //     prop: 'alarmId'
      //   },
      {
        label: that.$t('historyAlarm.title.subsystem'),
        prop: 'subSystem'
      },
      // {
      //   label: that.$t('historyAlarm.title.alarmType'),
      //   prop: 'alarmTypelabel',
      //   search: false,
      //   searchSlot:false
      // },
      {
        label: that.$t('historyAlarm.title.alarmState'),
        prop: 'alarmState',
        slot: true
      },
      {
        label: '设备组名称',
        prop: 'deviceWorkGroupName'
      }
    ]
  }
}